module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "admin-page-header"
    }
  }, [_c('blockquote', [_c('h3', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("admin-header-slot")], 2), _vm._v(" "), _c('section', {
    staticClass: "clearfix",
    attrs: {
      "id": "admin-common-ops"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6",
    attrs: {
      "id": "admin-buttons"
    }
  }, [_vm._t("buttons"), _vm._v(" "), (_vm.showNewButton) ? _c('div', {
    staticClass: "btn btn-success sq",
    on: {
      "click": function($event) {
        return _vm.$emit('create-entity-request')
      }
    }
  }, [_vm._v("\n        New "), _c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": function($event) {
        return _vm.$emit('open-filter')
      }
    }
  }, [_vm._v("\n        Filter "), _c('i', {
    staticClass: "fa fa-filter"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.emitSearch.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disableQuickSearch,
      "type": "text",
      "placeholder": _vm.searchPlaceholder,
      "id": "admin-filter-search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.disableQuickSearch ? 'disabled' : '', 'input-group-addon'],
    on: {
      "click": _vm.emitSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-350b86e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/AdminHeader.vue
// module id = 2147
// module chunks = 1